/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown>, price: NonNullable<unknown>, days: NonNullable<unknown>, period: NonNullable<unknown> }} Receipt_Formula_OfInputs */



/**
* | output |
* | --- |
* | "{count} × {price} × {days} of {period} days" |
*
* @param {Receipt_Formula_OfInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const receipt_formula_of = /** @type {((inputs: Receipt_Formula_OfInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Receipt_Formula_OfInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} × ${i?.price} × ${i?.days} von ${i?.period} Tagen`)
	return /** @type {LocalizedString} */ (`${i?.count} × ${i?.price} × ${i?.days} of ${i?.period} days`)
});